import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { getCookie } from "../../utils/CookieHelper";
import { COOKIE_ENUM, URL_PARAMS } from "../../utils/enums";
import { FranchiseDeliveryConfig } from "../../utils/types";
import { getFranchiseIsOpenData } from "../redux/http/getFranchiseConfig";
import {
  checkFranchiseCartRedux,
  resetSelectedScheduleOptions,
} from "../redux/slices/cartAndLoyaltySlice";
import { resetCartAction } from "../redux/slices/cartLoyaltyV2Slice";
import {
  clearCartDueToRestaurantSwitchFlag,
  setRestaurantSwitchInProgress,
  setSelectedFranchise,
} from "../redux/slices/configSlice";
import { setCurrentDeliveryConfig } from "../redux/slices/deliverySlice";
import { setBottomSheetState } from "../redux/slices/globalComponentsToggleSlice";
import { Franchise } from "./../../utils/types";
import { useAppDispatch, useAppSelector } from "./useReduxHooks";

const useFranchiseData = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { franchise, order_type } = router.query;

  const selectedFranchise = useAppSelector(
    (state) => state.config.selectedFranchise
  );
  const mainFranchise = useAppSelector(
    (state) => state.config.restaurantInfo?.mainFranchise
  );
  const activeFranchises = useAppSelector(
    (state) => state.config.activeFranchises
  );

  const delivery = useAppSelector((state) => state.delivery);
  const token = useAppSelector((state) => state.userInfo.token);

  const orderTypeParamState = useAppSelector(
    (state) => state.queryParams.orderTypeParam
  );

  const cartAndLoyalty = useAppSelector((state) => state.cartAndLoyaltyReducer);

  const selfService = useAppSelector(
    (state) => state.franchiseStatus.selfService
  );

  const shouldClearCartDueToRestaurantSwitch = useAppSelector(
    (state) => state.config.shouldClearCartDueToRestaurantSwitch
  );

  useEffect(() => {
    if (!getCookie(COOKIE_ENUM.TOKEN)) {
      return;
    }
    if (selectedFranchise?.id) {
      dispatch(checkFranchiseCartRedux(selectedFranchise?.id));
      if (cartAndLoyalty.cart.franchiseId !== selectedFranchise.id) {
        dispatch(resetCartAction());
      }
      dispatch(
        getFranchiseIsOpenData({
          franchiseId: selectedFranchise?.id,
          orderType: orderTypeParamState,
        })
      );
    }
  }, [selectedFranchise?.id, mainFranchise?.id, token]);

  useEffect(() => {
    if (!selfService) {
      const lastSelectedFranchise = Cookies.get(
        COOKIE_ENUM.LAST_SELECTED_FRANCHISE
      );
      if (!lastSelectedFranchise) {
        dispatch(setBottomSheetState(true));
      }
    }
  }, []);

  useEffect(() => {
    // Skip if router is not ready to prevent race conditions
    if (!router.isReady) {
      return;
    }

    const franchiseFromSlug = activeFranchises.find(
      (fr: Franchise) => fr.slug === franchise
    );

    if (
      selectedFranchise?.id !== franchiseFromSlug?.id ||
      !selectedFranchise?.id
    ) {
      const currentPath = window.location.pathname;
      const regexPattern = new RegExp(`^(/.*)?/${URL_PARAMS.TABLE}$`);

      if (currentPath === "/" || regexPattern.test(currentPath)) {
        // dispatch(setSelectedFranchise(franchiseFromSlug
      } else {
        if (franchiseFromSlug && order_type && order_type !== "undefined") {
          dispatch(setSelectedFranchise(franchiseFromSlug));
        }
      }
    }
  }, [selectedFranchise?.id, mainFranchise?.id, router.isReady]);

  useEffect(() => {
    if (selectedFranchise?.franchiseConfig.deliveryV2) {
      const newFranchiseDeliveryConfig =
        selectedFranchise.franchiseConfig.deliveryV2.find(
          (deliveryConfig: FranchiseDeliveryConfig) =>
            deliveryConfig.deliveryType.id ===
            delivery.currentDeliveryConfig?.deliveryType.id
        );
      dispatch(setCurrentDeliveryConfig(newFranchiseDeliveryConfig || null));
    }

    if (
      selectedFranchise &&
      !selectedFranchise?.franchiseConfig?.scheduledOrder
    ) {
      dispatch(resetSelectedScheduleOptions());
    }
  }, [selectedFranchise?.id]);

  // Handle cart clearing when switching between partner restaurants
  useEffect(() => {
    if (shouldClearCartDueToRestaurantSwitch) {
      console.log("Clearing cart due to partner restaurant switch");
      dispatch(resetCartAction());
      dispatch(clearCartDueToRestaurantSwitchFlag());

      // Clear the restaurant switch in progress flag after a short delay
      // to allow state updates to settle
      setTimeout(() => {
        dispatch(setRestaurantSwitchInProgress(false));
      }, 100);
    }
  }, [shouldClearCartDueToRestaurantSwitch]);
};

export default useFranchiseData;
